module.exports = __webpack_public_path__ + "img/service_productdesign.ba225283.png";